export const getAmountError = (amount: number) => {
  if (amount < 10) {
    return "Your entered amount is lower than the $10 minimum amount you can pay with debit card.";
  }
  if (amount > 5000) {
    return "Your entered amount exceeds the $5,000 maximum amount you can pay with debit card.";
  }

  return "";
};
